// extracted by mini-css-extract-plugin
export default {"radio":"DeleteModalView_radio__qIVTz"};